import React, { useState } from 'react'
import SydInput from '../../../commonDesign/SydInput'
import SydLabel from '../../../commonDesign/SydLabel'
import { useVaultContext } from '../VaultContextProvider'
import { useDebouncedCallback } from '../../../../hooks'

const SearchFilter = () => {
  const { setFilters, filters } = useVaultContext()
  const [searchString, setSearchString] = useState('')

  const debouncedContextUpdate = useDebouncedCallback((string) => {
    setFilters({ ...filters, textSearch: string })
  })

  return (
    <SydLabel label='Document Search:'>
      <SydInput
        size='sm'
        label='Search'
        placeholder='Name, tag, filetype, etc.'
        value={searchString}
        onChange={(e) => {
          setSearchString(e.target.value)
          debouncedContextUpdate(e.target.value)
        }}
      />
    </SydLabel>
  )
}
export default SearchFilter
